export default __webpack_public_path__ + "media/images/front/about/point_2_img-892717cfef93c21a8a853920ce48592f.jpg";